import React, {useState} from "react";
import {NavLink, useNavigate} from "react-router-dom";
import {MdDashboard, MdEmail, MdKeyboardArrowDown, MdKeyboardArrowUp} from "react-icons/md";
import {Can} from "../../Can";

const EmailDropdownSidebar = ({thememode}) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const handleMainClick = () => {
        // Navigate to the default dashboard page
        navigate("/Emails");
    };

    const handleArrowClick = (e) => {
        e.stopPropagation(); // Prevent triggering the main click
        setIsOpen(!isOpen);
    };

    return (
        <div className="mb-1">
            <div
                className={`flex items-center justify-between p-3 pl-6 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300`}
                onClick={handleMainClick}
            >
                <div className={'flex items-center '}>
                    <MdEmail className="mr-3"/>
                    <span className="flex-grow">Emails</span>
                </div>
                <div
                    className="p-1 hover:bg-gray-300 dark:hover:bg-gray-600 rounded"
                    onClick={handleArrowClick}
                >
                    {isOpen ? <MdKeyboardArrowUp/> : <MdKeyboardArrowDown/>}
                </div>
            </div>

            {isOpen && (
                <div>
                    <Can I="index" a="adminCampaign">
                    <NavLink
                        to="/Campaigns"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Admin Campaigns</span>
                    </NavLink>
                    </Can>
                    <Can I={'index'} a={'userCampaign'}>
                        <NavLink
                            to="/UserCampaigns"
                            className={({isActive}) =>
                                `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                    isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                                }`
                            }
                        >
                            <span>User Campaigns</span>
                        </NavLink>
                    </Can>

                </div>
            )}
        </div>
    );
};

export default EmailDropdownSidebar;